<template>
  <el-table-column
    prop="manufacturer.name"
    sortable="custom"
    label="Gyártó"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.manufacturer">{{ scope.row.manufacturer.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'manufacturer.name',
  };
</script>
